import { APPSUMO_PLAN_SLUGS } from './billing/top-plan'

export const CREDIT_PACK_MIN_CREDITS = 10_000
export const CREDIT_PACK_MAX_CREDITS = 100_000
export const CREDIT_PACK_STEP_CREDITS = 1_000
export const CREDIT_PACK_USD_PER_STEP = 3

const CREDIT_PACK_ALLOWED_PLAN_SLUGS = new Set([
  'creator',
  'starter',
  'pro',
  ...APPSUMO_PLAN_SLUGS,
])

export function canBuyCreditPack({
  planSlug,
  subscriptionStatus,
  isShopifyBilled,
  product = 'soku',
}: {
  planSlug: string | null
  subscriptionStatus: string | null
  isShopifyBilled: boolean
  product?: 'soku' | 'toolfare'
}): boolean {
  return (
    !isShopifyBilled &&
    (product === 'toolfare' ||
      (subscriptionStatus === 'active' &&
        planSlug !== null &&
        CREDIT_PACK_ALLOWED_PLAN_SLUGS.has(planSlug)))
  )
}

export function creditPackPriceUsd(credits: number): number {
  return (credits / CREDIT_PACK_STEP_CREDITS) * CREDIT_PACK_USD_PER_STEP
}

export function isValidCreditPackAmount(credits: number): boolean {
  return (
    Number.isInteger(credits) &&
    credits >= CREDIT_PACK_MIN_CREDITS &&
    credits <= CREDIT_PACK_MAX_CREDITS &&
    credits % CREDIT_PACK_STEP_CREDITS === 0
  )
}
